/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPromptCaching extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPromptCaching");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPromptCaching.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPromptCaching>): BackgroundJobPayloadForPromptCaching {
        let obj = Object.assign(new BackgroundJobPayloadForPromptCaching(), model);
        BackgroundJobPayloadForPromptCaching.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPromptCaching>): BackgroundJobPayloadForPromptCaching {
        if (!model) return null;
        return BackgroundJobPayloadForPromptCaching.newInstance(<BackgroundJobPayloadForPromptCaching> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPromptCaching) {
        if (!obj) return;

        models.BackgroundJobPayloadForPromptCaching.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPromptCaching): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPromptCaching.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service account whose prompts to run caching analysis for
     */
    service_account_id: string;

}
